var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArchivePro = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8662 18H18.1342C18.6102 18 19.0002 17.61 19.0002 17.134V16.866C19.0002 16.39 18.6102 16 18.1342 16H13.8662C13.3892 16 13.0002 16.39 13.0002 16.866V17.134C13.0002 17.61 13.3892 18 13.8662 18ZM22 22C22 22.551 21.552 23 21 23H11C10.449 23 10 22.551 10 22V13H22V22ZM10 9H22C22.552 9 23 9.449 23 10C23 10.551 22.552 11 22 11H10C9.449 11 9 10.551 9 10C9 9.449 9.449 9 10 9ZM25 10C25 8.346 23.654 7 22 7H10C8.346 7 7 8.346 7 10C7 10.883 7.391 11.67 8 12.22V22C8 23.654 9.346 25 11 25H21C22.654 25 24 23.654 24 22V12.22C24.609 11.67 25 10.883 25 10Z",
    fill: "#596C80"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArchivePro, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/archive_pro.e38f98bd.svg";
export { ForwardRef as ReactComponent };